import { FC } from 'react';

import { Preview } from '@appcharge/shared-ui';
import isEmpty from 'lodash/isEmpty';
import { Loader2 } from 'lucide-react';

interface StoreThemeData {
  [key: string]: unknown;
}

interface BundlePreviewSectionProps {
  previewProps: React.ComponentProps<typeof Preview>;
  storeThemeData: StoreThemeData;
}

const BundlePreviewSection: FC<BundlePreviewSectionProps> = ({
  previewProps,
  storeThemeData
}) => {
  return (
    <div className="w-1/2 h-full bg-zinc-100 px-16 pt-9 pb-8 overflow-y-auto">
      {/* Preview */}
      <div className="flex gap-12 justify-center items-center min-h-[667px]">
        {!isEmpty(storeThemeData) && !isEmpty(previewProps.offers) ? (
          <div className="w-[450px] h-[682px]">
            <Preview {...previewProps} hideHeader hideFooter />
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <Loader2 className="h-16 w-16 animate-spin text-indigo-300" />
          </div>
        )}
      </div>
    </div>
  );
};

export default BundlePreviewSection;
